import axios from 'lib/axios'

const getTalentsResults = async (id: any, quadrant: string) => {
  const quadrantResults = await axios
    .get(`/betesa_results/users_list/${id}?quadrant=${quadrant}`)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return { ok: false, message: error.message }
    })

  return quadrantResults
}

export default getTalentsResults
